import React from 'react'

import Container from '../Container'

import styles from '../../compounds/Navbar/styles'

const BareBonesNavbar = () => {
  return (
    <nav className={styles.wrapper}>
      <Container className={styles.container} />
    </nav>
  )
}

export default BareBonesNavbar
